import { createContext } from "react";
import type { Workspace } from "./workspaceTypes";

/** Private to `shell/workspace/`: features use `useWorkspace()`. Each tab provides its own; the window's chrome gets the active tab's. */
export const WorkspaceContext = createContext<Workspace | null>(null);
